export default "__VITE_ASSET__NWFYXN8B__"